import React, { memo } from "react";
import { Controller } from "react-hook-form";

import { ReactComponent as IconInputError } from "../../../../assets/images/IconInputError.svg";

import { Container, Label, Error, InputPassword } from "./styles";

const AuthInputPassword = ({ label, control, name, rules, error, ...rest }) => (
  <Container>
    <Label>{label}</Label>

    <Controller
      control={control}
      rules={rules}
      name={name}
      render={({ field }) => (
        <InputPassword
          suffix={error ? <IconInputError /> : <span />}
          status={error ? "error" : ""}
          placeholder={label}
          {...rest}
          {...field}
        />
      )}
    />

    {error && <Error>{error}</Error>}
  </Container>
);

export default memo(AuthInputPassword);
